"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ramda = require("ramda");
var _sharePoint = require("./sharePoint.helpers");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var asyncError = function asyncError(message) {
  return function () {
    return Promise.reject(new Error(message));
  };
};
var notSupportedAsyncError = function notSupportedAsyncError(methodName) {
  return asyncError("".concat(methodName, " is not supported in server-side SharePoint access"));
};
var sharePointAccess = function sharePointAccess(apiBase) {
  var get = apiBase.makeServiceGetRequestAsync,
    post = apiBase.makeServicePostRequestAsync,
    getXmlAsync = apiBase.getXmlAsync,
    callCrossDomainRequestAsync = apiBase.callCrossDomainRequestAsync,
    callHelperGet = apiBase.callHelperGet,
    callHelperPost = apiBase.callHelperPost;
  var hostRootSiteUrl = null;
  function checkFolderAsync(siteUrl, rootFolderUrl, folderName) {
    return post('WebProxy/CheckFolderExists', {
      siteUrl: siteUrl,
      rootFolderUrl: rootFolderUrl,
      folderName: folderName
    });
  }
  function createFolderAsync(siteUrl, libraryName, folderName) {
    return post('WebProxy/CreateSharePointFolder', {
      siteUrl: siteUrl,
      libraryName: libraryName,
      folderName: folderName
    });
  }
  function getTaxonomyFieldsSchemaAsync(siteUrl, listName) {
    return post('WebProxy/GetTaxnonomyFieldsSchema', {
      siteUrl: siteUrl,
      listName: listName
    });
  }
  function searchPeoplePickerUserAsync(siteUrl, searchPattern, searchPeopleOnly, maxCount) {
    return post('WebProxy/SearchPeoplePickeUser', {
      siteUrl: siteUrl,
      searchPattern: searchPattern,
      searchPeopleOnly: searchPeopleOnly,
      maxCount: maxCount
    });
  }
  function getListRootFolderUrlAsync(siteUrl, libraryName) {
    return post('WebProxy/GetListRootFolderUrl', {
      siteUrl: siteUrl,
      libraryName: libraryName
    });
  }
  function submitToLibraryAsync(location, fileName, file, overwrite, isBase64) {
    var sanitizedFolderUrl = (0, _sharePoint.ensureSlash)(location);
    return post('WebProxy/SubmitToLibrary', {
      location: sanitizedFolderUrl,
      fileName: fileName,
      file: file,
      overwrite: overwrite || false,
      isBase64: isBase64 || false
    }).then(function (data) {
      var errMsg = 'There was an error while submitting to the library.';
      if (!data) {
        throw new Error(errMsg);
      }
      if (!data.success) {
        var errorMessage = data.message || errMsg;
        var error = new Error(errorMessage);
        error.userDisplayMessage = errorMessage;
        throw error;
      }
      return data;
    });
  }
  var parseJsonSafe = (0, _ramda.tryCatch)(JSON.parse, (0, _ramda.always)(null));
  function handleApiError(apiResult) {
    var errorResult = parseJsonSafe(apiResult.resultBody);
    var errorValue = (0, _sharePoint.findRestError)(errorResult);
    if (errorValue) {
      throw new Error(errorValue);
    }

    //fallback
    throw new Error(apiResult.message);
  }
  var makeRestApiRequestAsync = function makeRestApiRequestAsync(siteUrl, apiPath, method) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      contentType = _ref.contentType,
      content = _ref.content,
      headers = _ref.headers,
      listId = _ref.listId,
      listName = _ref.listName,
      _ref$isBinary = _ref.isBinary,
      isBinary = _ref$isBinary === void 0 ? false : _ref$isBinary,
      _ref$resultHandler = _ref.resultHandler,
      resultHandler = _ref$resultHandler === void 0 ? JSON.parse : _ref$resultHandler;
    var fullRequestPath = "".concat((0, _sharePoint.getApiPathPrefix)(siteUrl)).concat(apiPath);
    var request = {
      method: method,
      url: fullRequestPath,
      content: content,
      contentType: contentType,
      isBinary: isBinary,
      sharePointSiteUrl: siteUrl,
      listId: listId,
      listName: listName,
      headers: _objectSpread({
        Accept: _sharePoint.JSON_ACCEPT_MIMETYPE
      }, headers)
    };
    return callCrossDomainRequestAsync(request).then(function (result) {
      if (result.success) {
        return resultHandler(result.resultBody, result);
      }
      return handleApiError(result);
    });
  };
  function submitFileToApiPathAsync(siteUrl, apiPath, fileContent) {
    return makeRestApiRequestAsync(siteUrl, apiPath, 'POST', {
      content: fileContent,
      isBinary: true
    });
  }
  var queryXmlAsync = function queryXmlAsync(url) {
    return getXmlAsync(url, {
      isSharepoint: true
    });
  };
  var getRootSiteUrlAsync = function getRootSiteUrlAsync() {
    if (hostRootSiteUrl) {
      return Promise.resolve(hostRootSiteUrl);
    }
    return get('WebProxy/GetRootSiteUrl').then(function (data) {
      if (!data.Success) {
        throw new Error('Could not determine root site url');
      }
      return data.Url;
    })["finally"](function (url) {
      hostRootSiteUrl = url;
    });
  };
  var querySpListAsync = function querySpListAsync(q) {
    return callHelperPost('WebProxy/QueryList', q).then(function (items) {
      return {
        items: items
      };
    });
  };

  // ListSubmitRequest -> Promise[[SubmittedListItemInfo]]
  var submitToListAsync = function submitToListAsync(container) {
    return callHelperPost('WebProxy/SubmitToList', container);
  };

  // String -> Promise[Boolean]
  var fileExistsAsync = function fileExistsAsync(url) {
    return callHelperGet('WebProxy/FileExists', {
      path: url
    });
  };
  var getListsAndLibrariesBySiteUrlAsync = function getListsAndLibrariesBySiteUrlAsync(siteUrl) {
    return callHelperGet('WebProxy/GetListsAndLibrariesBySiteUrl', {
      siteUrl: siteUrl
    });
  };
  var getColumnsByListIdAsync = function getColumnsByListIdAsync(siteUrl, listId) {
    return callHelperGet('WebProxy/GetColumnsByListId', {
      siteUrl: siteUrl,
      listId: listId
    });
  };
  var deleteFileAsync = function deleteFileAsync(url) {
    return callHelperPost('WebProxy/DeleteSharePointFile', {
      url: url
    });
  };
  var getListIdByNameAsync = function getListIdByNameAsync(siteUrl, listName) {
    return callHelperGet('WebProxy/GetListIdByName', {
      siteUrl: siteUrl,
      listName: listName
    });
  };
  var deleteListItemsAsync = function deleteListItemsAsync(siteUrl, listIdentifier, useListName, ids) {
    return post('WebProxy/DeleteListItems', {
      siteUrl: siteUrl,
      listIdentifier: listIdentifier,
      useListName: useListName,
      ids: ids
    });
  };
  var getSiteUserAsync = function getSiteUserAsync(userName) {
    return callHelperGet('WebProxy/GetSiteUser', {
      userName: userName
    }).then(JSON.parse);
  };
  var getTermSetsAsync = function getTermSetsAsync(type, siteUrl, lcid, queryOptions) {
    return callHelperPost('WebProxy/QueryTermSets', _objectSpread({
      type: type,
      siteUrl: siteUrl,
      lcid: lcid
    }, queryOptions));
  };
  var translateSharePointValuesAsync = function translateSharePointValuesAsync(siteUrl, values) {
    return callHelperPost('WebProxy/TranslateSharePointValues', {
      siteUrl: siteUrl,
      values: values
    });
  };
  var loadUserAsync = function loadUserAsync(userName, extraPropertyNames) {
    return callHelperPost('WebProxy/GetUserProfile', {
      userName: userName,
      extraPropertyNames: extraPropertyNames
    });
  };
  return {
    type: 'server',
    checkFolderAsync: checkFolderAsync,
    createFolderAsync: createFolderAsync,
    deleteFileAsync: deleteFileAsync,
    fileExistsAsync: fileExistsAsync,
    deleteListItemsAsync: deleteListItemsAsync,
    getColumnsByListIdAsync: getColumnsByListIdAsync,
    getListIdByNameAsync: getListIdByNameAsync,
    getListItemAsync: notSupportedAsyncError('getListItemAsync'),
    getListRootFolderUrlAsync: getListRootFolderUrlAsync,
    getListsAndLibrariesBySiteUrlAsync: getListsAndLibrariesBySiteUrlAsync,
    getTermSetsAsync: getTermSetsAsync,
    getRootSiteUrlAsync: getRootSiteUrlAsync,
    loadUserAsync: loadUserAsync,
    makeRestApiRequestAsync: makeRestApiRequestAsync,
    querySpListAsync: querySpListAsync,
    queryXmlAsync: queryXmlAsync,
    submitFileToApiPathAsync: submitFileToApiPathAsync,
    submitToLibraryAsync: submitToLibraryAsync,
    submitToListAsync: submitToListAsync,
    searchPeoplePickerUserAsync: searchPeoplePickerUserAsync,
    getSiteUserAsync: getSiteUserAsync,
    getTaxonomyFieldsSchemaAsync: getTaxonomyFieldsSchemaAsync,
    translateSharePointValuesAsync: translateSharePointValuesAsync
  };
};
var _default = exports["default"] = sharePointAccess;